import { render, staticRenderFns } from "./lawyer-payment-tab.vue?vue&type=template&id=6b25ed15&"
import script from "./lawyer-payment-tab.vue?vue&type=script&lang=js&"
export * from "./lawyer-payment-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports